const productData = [
  {
    id: 1,
    name: "Rock Ridge Carpenter Pant",
    category: "Pants",
    price: "108.00",
    reviews: "342",
    rating: "4.6",
    image: "/img/101.avif",
    images: [
      "/img/101.avif",
      "/img/101a.avif",
      "/img/101b.avif",
      "/img/101c.avif",
      "/img/101d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Cream", "Light Blue"],
    material: "100% Organic Cotton Denim",
    description: [
      "Tackle your next project or weekend adventure with the Rock Ridge Carpenter Pant.",
      "Made with durable organic cotton canvas that offers just the right amount of stretch.",
      "Features a relaxed fit with classic carpenter details like a hammer loop and utility pockets.",
      "Articulated knees provide enhanced mobility for climbing or hiking.",
      "Garment-washed for a lived-in feel from day one.",
    ],
    Features: [
      "Organic cotton blend canvas",
      "Classic carpenter styling with utility pockets",
      "Articulated knees for range of motion",
      "UPF 50+ sun protection",
      "Fair Trade Certified™ factory",
    ],
  },
  {
    id: 2,
    name: "Emberbrook Sweater",
    category: "Sweaters",
    price: "88.00",
    reviews: "289",
    rating: "4.7",
    image: "/img/102.avif",
    images: [
      "/img/102.avif",
      "/img/102a.avif",
      "/img/102b.avif",
      "/img/102c.avif",
      "/img/102d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Plum", "Charcoal"],
    material: "Recycled Wool Blend",
    description: [
      "Stay cozy during crisp morning hikes or chilly evenings around the campfire.",
      "The Emberbrook Sweater is crafted from a sustainable blend of recycled wool and nylon.",
      "Features a classic crew neckline and rib-knit cuffs to keep the cold out.",
      "Naturally odor-resistant and moisture-wicking properties keep you fresh.",
      "A versatile layering piece that transitions seamlessly from trail to town.",
    ],
    Features: [
      "Recycled wool blend for sustainable warmth",
      "Naturally odor-resistant and temperature regulating",
      "Rib-knit cuffs, collar, and hem",
      "Standard fit for easy layering",
      "Bluesign® approved materials",
    ],
  },
  {
    id: 3,
    name: "Rockblock Rugby Shirt",
    category: "Tops",
    price: "130.00",
    reviews: "214",
    rating: "4.5",
    image: "/img/103.avif",
    images: [
      "/img/103.avif",
      "/img/103a.avif",
      "/img/103b.avif",
      "/img/103c.avif",
      "/img/103d.avif",
      "/img/103e.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Brown Stripe", "Mulberry"],
    material: "Organic Cotton Jersey",
    description: [
      "A modern take on a classic, the Rockblock Rugby Shirt is built for active days.",
      "Constructed from heavyweight organic cotton that can withstand rigorous outdoor use.",
      "Features a traditional twill collar and rubberized buttons for authentic style.",
      "Underarm gussets provide maximum freedom of movement when reaching for holds.",
      "Relaxed fit ensures comfort whether you're belaying or relaxing at the crag.",
    ],
    Features: [
      "100% Organic Cotton heavyweight jersey",
      "Traditional rugby collar with rubber buttons",
      "Underarm gussets for enhanced mobility",
      "Rib-knit cuffs",
      "Pre-shrunk for a consistent fit",
    ],
  },
  {
    id: 4,
    name: "Parkhaven Heritage Zip Flannel",
    category: "Jackets",
    price: "125.00",
    reviews: "178",
    rating: "4.6",
    image: "/img/104.avif",
    images: [
      "/img/104.avif",
      "/img/104a.avif",
      "/img/104b.avif",
      "/img/104c.avif",
      "/img/104d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Beige", "Tan"],
    material: "Organic Cotton Flannel",
    description: [
      "A versatile zip-up flannel that doubles as a lightweight jacket for transitional weather.",
      "Made from a brushed organic cotton blend that feels incredibly soft against the skin.",
      "Features a full front zipper for easy temperature regulation on the go.",
      "Dual chest pockets with button closures keep your small essentials secure.",
      "Classic plaid patterns bring a timeless outdoor aesthetic to your wardrobe.",
    ],
    Features: [
      "Brushed organic cotton flannel",
      "Full zip front closure",
      "Dual button-flap chest pockets",
      "Side seam hand pockets",
      "Relaxed fit for easy layering",
    ],
  },
  {
    id: 5,
    name: "Rock Ridge Overshirt",
    category: "Tops",
    price: "120.00",
    reviews: "305",
    rating: "4.8",
    image: "/img/105.avif",
    images: [
      "/img/105.avif",
      "/img/105a.avif",
      "/img/105b.avif",
      "/img/105c.avif",
      "/img/105d.avif",
    ],
    size: ["S", "M", "L", "XL", "XXL"],
    colors: ["Brown", "Gold"],
    material: "Hemp and Recycled Polyester Blend",
    description: [
      "The perfect mid-layer for unpredictable weather, combining shirt styling with jacket warmth.",
      "Crafted from a durable hemp and recycled polyester blend for sustainable performance.",
      "Features a snap-front closure and a slightly oversized fit for easy layering over tees.",
      "Reinforced elbows add durability for scrambling and bushwhacking.",
      "Equipped with two oversized chest pockets for quick access to trail maps or snacks.",
    ],
    Features: [
      "Sustainable hemp and recycled polyester blend",
      "Snap front closure",
      "Reinforced elbow patches",
      "Oversized chest pockets",
      "UPF 30+ sun protection",
    ],
  },
  {
    id: 6,
    name: "Rock Ridge Chino Pant",
    category: "Pants",
    price: "98.00",
    reviews: "198",
    rating: "4.4",
    image: "/img/106.avif",
    images: [
      "/img/106.avif",
      "/img/106a.avif",
      "/img/106b.avif",
      "/img/106c.avif",
      "/img/106d.avif",
    ],
    size: ["28", "30", "32", "34", "36", "38"],
    colors: ["Khaki", "Beige"],
    material: "Organic Cotton Stretch Canvas",
    description: [
      "Elevate your everyday outdoor wardrobe with the versatile Rock Ridge Chino Pant.",
      "Made with our signature stretch canvas for maximum comfort and durability.",
      "A tailored straight-leg fit provides a clean look that works in the office or on the trail.",
      "Features a gusseted crotch for unrestricted movement during active pursuits.",
      "Garment-dyed for a rich color and soft, broken-in feel.",
    ],
    Features: [
      "Stretch organic cotton canvas",
      "Gusseted crotch for mobility",
      "Classic 5-pocket chino styling",
      "Straight leg fit",
      "Fair Trade Certified™ factory",
    ],
  },
  {
    id: 7,
    name: "Westbrook Flannel Shirt",
    category: "Tops",
    price: "135.00",
    reviews: "240",
    rating: "4.7",
    image: "/img/107.avif",
    images: [
      "/img/107.avif",
      "/img/107a.avif",
      "/img/107b.avif",
      "/img/107c.avif",
      "/img/107d.avif",
    ],
    size: ["S", "M", "L", "XL", "XXL"],
    colors: ["Plaid", "Heather"],
    material: "Organic Cotton Flannel",
    description: [
      "The Westbrook Flannel is a quintessential outdoor staple for cool weather adventures.",
      "Constructed from midweight organic cotton flannel that provides breathable warmth.",
      "Features a classic button-down front and dual chest pockets with flap closures.",
      "The back pleat allows for an extended range of motion across the shoulders.",
      "Available in a variety of heritage-inspired plaid patterns.",
    ],
    Features: [
      "100% Organic Cotton flannel",
      "Button-down front with dual chest pockets",
      "Back pleat for shoulder mobility",
      "Standard fit",
      "Bluesign® approved materials",
    ],
  },
  {
    id: 8,
    name: "Touchstone Henley",
    category: "Tops",
    price: "150.00",
    reviews: "190",
    rating: "4.8",
    image: "/img/108.avif",
    images: [
      "/img/108.avif",
      "/img/108a.avif",
      "/img/108b.avif",
      "/img/108c.avif",
      "/img/108d.avif",
    ],
    size: ["S", "M", "L", "XL", "XXL"],
    colors: ["Navy", "Olive"],
    material: "Organic Cotton Waffle Knit",
    description: [
      "A rugged yet comfortable henley designed for climbing, hiking, and everyday wear.",
      "Made from a textured organic cotton waffle knit that traps heat and breathes well.",
      "Features a classic three-button placket for quick ventilation.",
      "Raglan sleeves eliminate shoulder seam chafing under a backpack.",
      "A versatile base layer that looks great on its own or layered under a flannel.",
    ],
    Features: [
      "Organic cotton waffle knit thermal",
      "Three-button henley placket",
      "Raglan sleeves for pack compatibility",
      "Rib-knit cuffs",
      "Fair Trade Certified™ factory",
    ],
  },
  {
    id: 9,
    name: "Parkhaven Fleece Crew Sweatshirt",
    category: "Sweatshirts",
    price: "145.00",
    reviews: "256",
    rating: "4.7",
    image: "/img/109.avif",
    images: [
      "/img/109.avif",
      "/img/109a.avif",
      "/img/109b.avif",
      "/img/109c.avif",
      "/img/109d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Cream", "Stone"],
    material: "Organic Cotton & Recycled Polyester Fleece",
    description: [
      "Experience ultimate comfort with the Parkhaven Fleece Crew Sweatshirt.",
      "Crafted from a plush blend of organic cotton and recycled polyester fleece.",
      "Features a classic crewneck design with V-notch detailing at the neckline.",
      "Ribbed side panels provide a flexible, active fit that moves with you.",
      "Perfect for post-yoga lounging or chilly morning dog walks.",
    ],
    Features: [
      "Organic cotton and recycled polyester fleece",
      "Classic crewneck with V-notch detail",
      "Ribbed side panels for flexibility",
      "Standard fit",
      "Fair Trade Certified™ factory",
    ],
  },
  {
    id: 10,
    name: "Luxara™ 7/8 Legging",
    category: "Leggings",
    price: "130.00",
    reviews: "312",
    rating: "4.9",
    image: "/img/1010.avif",
    images: [
      "/img/1010.avif",
      "/img/1010a.avif",
      "/img/1010b.avif",
      "/img/1010c.avif",
      "/img/1010d.avif",
    ],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Olive", "Charcoal"],
    material: "Luxara™ Recycled Nylon Blend",
    description: [
      "Flow through your vinyasa with the ultra-lightweight Luxara™ 7/8 Legging.",
      "Made from our signature Luxara™ fabric, offering a barely-there feel with gentle compression.",
      "Features a wide, high-rise waistband that stays in place during inversions.",
      "Moisture-wicking and quick-drying properties keep you comfortable during sweaty sessions.",
      "A hidden key pocket in the waistband provides convenient storage.",
    ],
    Features: [
      "Ultralight Luxara™ fabric with gentle compression",
      "High-rise, wide waistband",
      "Moisture-wicking and quick-drying",
      "UPF 50+ sun protection",
      "Hidden waistband pocket",
    ],
  },
  {
    id: 11,
    name: "Parkhaven Heritage Hoodie",
    category: "Sweatshirts",
    price: "120.00",
    reviews: "198",
    rating: "4.6",
    image: "/img/1011.avif",
    images: ["/img/1011.avif", "/img/1011a.avif", "/img/1011b.avif"],
    size: ["XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Dark Brown", "Rose"],
    material: "Organic Cotton Blend Fleece",
    description: [
      "Celebrate our roots with the cozy and classic Parkhaven Heritage Hoodie.",
      "Made from a heavyweight organic cotton blend fleece for superior warmth.",
      "Features a lined drawstring hood and a roomy kangaroo front pocket.",
      "Adorned with our vintage-inspired heritage logo graphic on the chest.",
      "A relaxed fit makes it the ultimate pullover for rest days and road trips.",
    ],
    Features: [
      "Heavyweight organic cotton blend fleece",
      "Lined drawstring hood",
      "Kangaroo hand pocket",
      "Vintage-inspired graphic",
      "Ribbed cuffs and hem",
    ],
  },
  {
    id: 12,
    name: "Rock Ridge 5 Pocket Pant",
    category: "Pants",
    price: "115.00",
    reviews: "267",
    rating: "4.5",
    image: "/img/1012.avif",
    images: ["/img/1012.avif"],
    size: ["28", "30", "32", "34", "36", "38"],
    colors: ["Rust", "Blush"],
    material: "Organic Cotton Stretch Canvas",
    description: [
      "The classic 5-pocket pant reimagined for the modern outdoor enthusiast.",
      "Constructed from a durable, stretch-woven blend of organic cotton and spandex.",
      "Features a classic straight-leg fit that transitions effortlessly from crag to cafe.",
      "Reinforced rivets and double-stitched seams ensure long-lasting durability.",
      "A gusseted inseam provides the freedom of movement needed for bouldering.",
    ],
    Features: [
      "Stretch organic cotton blend",
      "Classic 5-pocket styling",
      "Gusseted inseam for mobility",
      "Reinforced rivets at stress points",
      "UPF 50+ sun protection",
    ],
  },
  {
    id: 13,
    name: "Heavana™ Every Minute Bra",
    category: "Bras",
    price: "125.00",
    reviews: "223",
    rating: "4.6",
    image: "/img/1013.avif",
    images: ["/img/1013.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Navy", "Stone"],
    material: "Heavana™ Recycled Polyester Blend",
    description: [
      "Find your center with the supportive and incredibly soft Heavana™ Every Minute Bra.",
      "Crafted from our peached Heavana™ fabric for a buttery-soft feel against the skin.",
      "Features a flattering V-neckline and a supportive racerback design.",
      "Removable modesty cups allow for customizable shape and coverage.",
      "Designed for low to medium-impact activities like yoga, pilates, and hiking.",
    ],
    Features: [
      "Buttery-soft Heavana™ fabric",
      "V-neckline with racerback design",
      "Removable modesty cups",
      "Low to medium impact support",
      "Moisture-wicking properties",
    ],
  },
  {
    id: 14,
    name: "Luxara™ Pocket Legging",
    category: "Leggings",
    price: "130.00",
    reviews: "198",
    rating: "4.7",
    image: "/img/1014.avif",
    images: ["/img/1014.avif", "/img/1014a.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Light Blue", "Black"],
    material: "Luxara™ Recycled Nylon Blend",
    description: [
      "Experience the perfect blend of performance and convenience with the Luxara™ Pocket Legging.",
      "Made from our ultralight Luxara™ fabric for a supportive, second-skin feel.",
      "Features deep side pockets that securely hold your phone, keys, or cards.",
      "A high-rise waistband provides flattering coverage and stays put during movement.",
      "Flatlock seams prevent chafing during long runs or intense studio sessions.",
    ],
    Features: [
      "Ultralight Luxara™ fabric",
      "Dual side drop-in pockets",
      "High-rise waistband",
      "Flatlock seams for chafe-free comfort",
      "UPF 50+ sun protection",
    ],
  },
  {
    id: 15,
    name: "Excursions Flannel Jacket",
    category: "Jackets",
    price: "150.00",
    reviews: "312",
    rating: "4.8",
    image: "/img/1015.avif",
    images: ["/img/1015.avif", "/img/1015a.avif"],
    size: ["S", "M", "L", "XL", "XXL"],
    colors: ["Blue Plaid", "Ivory"],
    material: "Organic Cotton Flannel & Quilted Insulation",
    description: [
      "Stay warm on chilly outdoor excursions with this heavily insulated flannel jacket.",
      "Features a rugged organic cotton flannel exterior with a quilted, insulated lining.",
      "A smooth taffeta lining in the sleeves allows for easy layering over sweaters.",
      "Equipped with snap-button chest pockets and side-seam handwarmer pockets.",
      "The perfect heavy-duty overshirt for chopping wood or setting up camp.",
    ],
    Features: [
      "Organic cotton flannel exterior",
      "Quilted insulation for exceptional warmth",
      "Smooth sleeve lining for easy layering",
      "Snap-front closure",
      "Side-seam handwarmer pockets",
    ],
  },
  {
    id: 16,
    name: "Discovery Trail Short",
    category: "Shorts",
    price: "120.00",
    reviews: "187",
    rating: "4.7",
    image: "/img/1016.avif",
    images: ["/img/1016.avif", "/img/1016a.avif"],
    size: ["28", "30", "32", "34", "36", "38"],
    colors: ["Dark Grey", "Olive"],
    material: "Recycled Nylon Blend",
    description: [
      "Hit the trail with confidence in the lightweight and durable Discovery Trail Short.",
      "Made from a recycled nylon blend that resists abrasions and dries in a flash.",
      "Features an elastic waistband with an adjustable drawcord for a secure, custom fit.",
      "Multiple zippered pockets keep your trail essentials safe and accessible.",
      "A durable water repellent (DWR) finish sheds light rain and trail splash.",
    ],
    Features: [
      "Recycled nylon blend with 4-way stretch",
      "Elastic waistband with drawcord",
      "Zippered front and back pockets",
      "PFC-free DWR finish",
      "UPF 50+ sun protection",
    ],
  },
  {
    id: 17,
    name: "Cuyamaca Boiler Suit",
    category: "Jumpsuits",
    price: "95.00",
    reviews: "234",
    rating: "4.6",
    image: "/img/1017.avif",
    images: ["/img/1017.avif", "/img/1017a.avif"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Olive Green", "White"],
    material: "Hemp & Organic Cotton Blend",
    description: [
      "Effortless one-piece styling meets outdoor utility in the Cuyamaca Boiler Suit.",
      "Constructed from a lightweight, breathable blend of hemp and organic cotton.",
      "Features a button-front closure, an elasticated back waist, and a relaxed fit.",
      "Multiple utility pockets provide ample storage for your everyday adventures.",
      "Roll up the sleeves and hem for a casual, warm-weather look.",
    ],
    Features: [
      "Breathable hemp and organic cotton blend",
      "Button-front closure",
      "Elasticated back waist for shape",
      "Utility chest and hand pockets",
      "Fair Trade Certified™ factory",
    ],
  },
  {
    id: 18,
    name: "Shea Soft Headband",
    category: "Headwear",
    price: "110.00",
    reviews: "201",
    rating: "4.6",
    image: "/img/1018.avif",
    images: ["/img/1018.avif", "/img/1018a.avif"],
    size: ["One size"],
    colors: ["Burgundy", "Sand"],
    material: "Recycled Polyester Blend",
    description: [
      "Keep your hair in place and sweat at bay with the Shea Soft Headband.",
      "Made from a moisture-wicking blend of recycled polyester and spandex.",
      "Features a wide, twisted design that stays securely in place during intense workouts.",
      "Incredibly soft and stretchy, providing all-day comfort without headaches.",
      "The perfect accessory for yoga, running, or hiding a bad hair day on the trail.",
    ],
    Features: [
      "Moisture-wicking recycled polyester blend",
      "Wide, twisted design",
      "4-way stretch for a secure fit",
      "Soft, headache-free comfort",
      "Bluesign® approved materials",
    ],
  },
  {
    id: 19,
    name: "Rock Ridge Jacket",
    category: "Jackets",
    price: "135.00",
    reviews: "276",
    rating: "4.8",
    image: "/img/1019.avif",
    images: ["/img/1019.avif", "/img/1019a.avif"],
    size: ["S", "M", "L", "XL", "XXL"],
    colors: ["Navy", "Ivory"],
    material: "Stretch Canvas with DWR",
    description: [
      "Brave the elements with the durable and weather-resistant Rock Ridge Jacket.",
      "Constructed from a tough, stretch-woven canvas with a water-repellent finish.",
      "Features an adjustable hood, full zip front, and storm flap to seal out the wind.",
      "Articulated sleeves and a gusseted back provide unrestricted movement for climbing.",
      "Ample pocket space ensures your gear is always within reach.",
    ],
    Features: [
      "Stretch-woven canvas with DWR finish",
      "Adjustable hood and hem",
      "Articulated sleeves for mobility",
      "Zippered chest and hand pockets",
      "Wind and water resistant",
    ],
  },
  {
    id: 20,
    name: "Ronnie Henley II",
    category: "Tops",
    price: "108.00",
    reviews: "189",
    rating: "4.6",
    image: "/img/1020.avif",
    images: ["/img/1020.avif"],
    size: ["S", "M", "L", "XL", "XXL"],
    colors: ["Light Grey", "Blush"],
    material: "Organic Cotton & Recycled Polyester Blend",
    description: [
      "Upgrade your everyday basics with the incredibly soft Ronnie Henley II.",
      "Crafted from a sustainable blend of organic cotton and recycled polyester.",
      "Features a classic henley placket with novelty buttons for added style.",
      "A slim, athletic fit makes it an ideal base layer or standalone piece.",
      "Garment-washed for a supremely soft, lived-in feel.",
    ],
    Features: [
      "Organic cotton and recycled polyester blend",
      "Classic henley placket",
      "Slim, athletic fit",
      "Soft, garment-washed finish",
      "Fair Trade Certified™ factory",
    ],
  },
];

export default productData;
